import React from 'react';

import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

import { useIntl } from 'src/hooks/intl';

import { messages } from './header-actions.i18n';

const mergeInProgressTextBoxStyle = xcss({
  display: 'flex',
});

export const MergeInProgressIndicator = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Box xcss={mergeInProgressTextBoxStyle} paddingInline="space.150">
      <Inline space="space.050" alignBlock="center">
        <Spinner size="small" />
        <Text>{intl.formatMessage(messages.mergeInProgressMessage)}</Text>
      </Inline>
    </Box>
  );
};
